window.addEventListener('load', function() {
	// console.log("Test");
	// BounceX tag -- Speed Optimization Trick
  (function(d) {
    var e = d.createElement('script');
    e.src = d.location.protocol + '//tag.bounceexchange.com/3733/i.js';
    e.async = true;
    d.getElementsByTagName("head")[0].appendChild(e);
  }(document));

	function loadScript(id, url, callback) {
    	let script = document.getElementById(id);
    	script.src = url;
    	script.onload = () => callback();
 	}

 	function loadCss(filename) {
 		var fileref = document.createElement("link");
    	fileref.setAttribute("rel", "stylesheet");
    	fileref.setAttribute("type", "text/css");
    	fileref.setAttribute("href", filename);
    	document.getElementsByTagName("head")[0].appendChild(fileref)
 	}

  setTimeout(function(){ 
	// START Zendesk Widget -- Speed Optimization Trick
	(function() {
		var s = document.createElement('script');
		s.type = 'text/javascript';
		s.id = 'ze-snippet';
		s.async = true;
		s.src = 'https://static.zdassets.com/ekr/snippet.js?key=ec7a0874-89dd-4191-9f9b-0ab6c16d983b';
		var x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);
	})()
	// END Zendesk Widget -- Speed Optimization Trick


		// Klaviyo -- Speed Optimization Trick
	  var __klKey = __klKey || 'zFxB6d';
	  (function() {
			var s = document.createElement('script');
			s.type = 'text/javascript';
			s.async = true;
			s.src = '//static.klaviyo.com/forms/js/client.js';
			var x = document.getElementsByTagName('script')[0];
			x.parentNode.insertBefore(s, x);
  	})();

		//Begin - Bing UET  -- Speed Optimization Trick
		// function GetRevenueValue()  { return 6; }    
		// (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"5988896"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq"); 
		// window.uetq = window.uetq || []; window.uetq.push({ 'ec':'purchase', 'gv': GetRevenueValue(), 'gc': 'USD'});  

		//Hotjar Tracking Code for www.kassatex.com -- Speed Optimization Trick
		// (function(h,o,t,j,a,r){
		//   h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
		//   h._hjSettings={hjid:979364,hjsv:6};
		//   a=o.getElementsByTagName('head')[0];
		//   r=o.createElement('script');r.async=1;
		//   r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
		//   a.appendChild(r);
		// })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');

		// Loop returns initialization
		/*LoopOnstore.init({
      key: "ac901f6b909ab664d6c9a6b917742b70a30427d1",
      attach: "#checkout_button"
    });*/

	}, 3000);

	setTimeout(function(){

    // BounceX
    // loadScript('bouncex','https://tag.bounceexchange.com/3733/i.js', script => {console.log('loaded bouncex')});
    
    // Load Findify -- Speed Optimization
		// Old script, new script on theme.liquid
  	// loadScript('findify-assets','https://findify-assets-2bveeb6u8ag.netdna-ssl.com/search/prod/kassatex.myshopify.com.min.js', script => {});

  	const $popupTemplate = $('.popup-promotion');
    if (localStorage.getItem('promotion_result_set_header') == 'true') {
      var announcement_text = localStorage.getItem('promotion_result_set_header_template');
      if ($('.header__bar .shell').length > 0) {
        $('.header__bar .shell').html(announcement_text);

        if ($('.header-checkout').length > 0 ) {
          $('.header-checkout').css({
            'margin-top': "30px"
          });
          $('.header__bar').css({
            'height': '30px'
          });
        }
      }
    } else {
      $('.header-checkout .header__bar').remove();
    }

    $('.slider h1').css('visibility', 'visible');
	}, 50);

});